import { render, staticRenderFns } from "./Docente.vue?vue&type=template&id=3442b46f&"
import script from "./Docente.vue?vue&type=script&lang=js&"
export * from "./Docente.vue?vue&type=script&lang=js&"
import style0 from "./Docente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports